<!-- 泊链方式第三方车场接入指南 -->
<template>
    <div class="content">
        <ul>
            <li>
                <h3 class="title">第三方车场接入说明</h3>
                <h4>架构图</h4>
                <div class="ShaShiDi">
                    <img src="/static/img/11.png"/>
                </div>
            </li>
        </ul>

        <ul>
            <li>
                <h4>对接协议</h4>
                <div>第三方停车管理系统与YDTO的对接有SDK、HTTP和netty等三种方式。</div>
                <div class="retract">SDK对接：LongPollingUtil实现（车场轮训获取ydto请求），AKEUploadUtil（停车场对ydto的上报）以及com.ake.its.park.core.ClientServiceResponseHandlerAdapter（停车场对ydto上报后，ydto的返回处理）。</div>
                <br/>
                <div class="retract">http对接：LongPollingUtil实现（车场轮训获取ydto请求），车场响应ydto、上报数据采用http方式调用ydto接口，也可以采用AKEUploadUtil方式完成数据上传ydto。</div>
                <br/>
                <div class="retract">netty对接：实现com.ake.its.park.core.ClientServiceRequestHandlerAdapterher（ydto对车场请求后，车场的返回处理）、AKEUploadUtil（停车场对ydto的上报）以及com.ake.its.park.core.ClientServiceResponseHandlerAdapter（停车场对ydto上报后，ydto的返回处理）。</div>
                <br/>
                <div class="retract">服务端：NettyServer、http Server</div>
                <div class="retract">客户端：NettyClient，分别提供java sdk和win SDK（稍后上线）、http</div>

            </li>
        </ul>



        <ul>
            <li>
                <h4 class="title">请求类接口</h4>
            </li>
            <li>
                <div>下行（数据从YDTO到第三方停车管理系统）接口的对接</div>
                <h4>SDK对接流程图</h4>
                <br/>
                <div class="ShaShiDi2">
                    <img src="/static/img/12.png"/>
                </div>
                <h4>http对接流程图</h4>
                <br/>
                <div class="ShaShiDi2">
                    <img src="/static/img/13.png"/>
                </div>
                <h4>netty对接流程图</h4>
                <br/>
                <div class="ShaShiDi2">
                    <img src="/static/img/17.png"/>
                </div>
                <h4>调用流程图</h4>
                <br/>
                <div class="ShaShiDi3">
                    <img src="/static/img/16.png"/>
                </div>
                <br/>
                <div>1.车场获取YDTO下发的下行数据需采用http轮询的方式,当YDTO有需要推送给车场的消息时,会获取JSON格式的下行消息。上行和下行的消息格式与上述SDK接口文档中定义的一致。轮询规则：车场发一个http长轮询请求到YDTO，YDTO会暂时不返回这个请求，等待30秒后返回无消息，如30秒内有消息会及时返回，车场收到http的返回或者判断超时后应及时再次发起一次请求，确保有且仅有一个http长轮询请求存在，如果发生断开要车场端主动发起新的连接。</div>
                <div>2.成功的响应如下：（status=1则认为成功，否则智慧停车开放平台认为推送失败）</div>
                <pre>{{JSON.stringify({"data": {}, "message": "ok", "resultCode": 0, "status": 1}, null, 4)}}</pre>
                <template>
                    <el-table
                    :data="respTable"
                    style="width: 100%">
                        <el-table-column
                            prop="info1"
                            label="变量名"
                            width="110">
                        </el-table-column>
                        <el-table-column
                            prop="info2"
                            label="是否必填"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="info3"
                            label="字段类型"
                             width="120">
                        </el-table-column>
                         <el-table-column
                            prop="info4"
                            label="字段名"
                            width="100">
                        </el-table-column>
                         <el-table-column
                            prop="info5"
                            label="说明">
                        </el-table-column>
                    </el-table>
                </template>
                <div>3.YDTO下发完整数据样例：</div>
                <pre>
                {
                    "parkCode": "2KNTYVWC",
                    "data": {
                        "serviceName": "queryFee",
                        "orderId": "123123123123123",
                        "carNumber": "粤AWDL55",
                        "payScene": 0,
                        "parkId": "2KNTYVWC",
                        "outChannelId": "A1",
                        "queryOrderNo": "4324324242423434"
                    }
                }
                </pre>
            </li>
        </ul>

        <ul>
            <li>
                <h4 class="title">上报类接口</h4>
            </li>
            <li>
                <div>上行（数据从第三方停车管理系统到YDTO）接口的对接</div>
                <div>1.对接HTTP模式时，相关接口将不再通过调用SDK的UploadUtil方法上传数据，而是采用发送HTTP请求的方式将上行的JSON串包，在http请求header中"Content-Type"设置为"application/json;charset=utf-8"，JSON串数据放置在body中，发送POST请求到YDTO服务器。</div>
                <div>2.组织上行数据时, 根据接口文档要求组织的SDK参数, 设为data, 例如初始化, data为:</div>
                <pre>
                Accept:application/json;
                Content-Type:application/json;charset=utf-8;
                Content-Length:256;
                Authorization:XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</pre>
                <div>3.车场上报完整数据样例：</div>
                <pre>
                {
                    "parkCode": "2KNTYVWC",
                    "data": {
                        "carType": "大车",
                        "uid": "325101",
                        "carNumber": "粤AWDL55",
                        "inTime": 1553220837000,
                        "orderId": "wdl20190322000000001",
                        "inChannelId": "A1",
                        "worksiteId": 23,
                        "cType": "通道扫牌",
                        "emptyPlot": 20,
                        "remark": "入场信息备注"
                    }
                }
                </pre>
                <div>

                </div>
            </li>
        </ul>

    </div>
</template>

<script>
export default {
    name: '',
    props: {
        'Pdatas': {
            type: Object,
        }
    },
    data() {
        return {
            respTable: [
                { info1: 'status', info2: '是', info3: 'int', info4: '状态码',info5:'1业务成功,2业务失败,3系统异常,4签名错误,5key错误,6未授权,7请求参数不完整' },
                { info1: 'resultCode', info2: '是', info3: 'int', info4: '业务码',info5:'只有状态码为2时才生效，状态码不为2时业务结果为0;901-系统发生异常,902-远程服务器未响应,903-运营商不存在,904-停车场不存在,905-未找到在场车辆,906-账单不存在,907-账单已同步,908-其它错误'},
                { info1: 'message', info2: '是', info3: 'String', info4: '结果描述' },
                { info1: 'data', info2: '是', info3: 'JSONObject', info4: '返回数据' }
            ],
            othersData: [],
            explainWidth: 200,
        }
    },
}
</script>

<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    line-height: 1.6;
    color: #1f2d3d;
    h3 {
        margin: 0;
        padding: 0px 0 20px 0; // font-family: HiraginoSansGB-W3;
        font-size: 18px;
        color: #111B29;
        letter-spacing: 0
    }
    a {
        font-size: 13px;
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
        }
    }
    .retract {
        padding-left: 15px;
    }
    pre {
        background-color: #f6f6f6;
        font-size: 12px;
    }
}

.subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
}

table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
    background-color: #f6f8f9;
}

table tr:first-child {
    border: none;
}

table tr {
    border-top: 1px solid #e7e7eb;
}

table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
}

table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
}

.ShaShiDi{
width:800px;
height:400px;
display:flex;
align-items:center;
justify-content:center;
}

.ShaShiDi img{
    width:100%;
    height:auto;
}

.ShaShiDi2{
width:800px;
height:570px;
display:flex;
align-items:center;
justify-content:center;
}

.ShaShiDi2 img{
    width:100%;
    height:auto;
}

.ShaShiDi3{
width:800px;
height:860px;
display:flex;
align-items:center;
justify-content:center;
}

.ShaShiDi3 img{
    width:100%;
    height:auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForBolian/intrduction.vue